import { useState } from 'react';

interface UseEditableTitleProps {
  initialValue: string;
  onSave: (value: string) => void;
}

export function useEditableTitle({ initialValue, onSave }: UseEditableTitleProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(initialValue);

  const startEditing = () => {
    setEditValue(initialValue);
    setIsEditing(true);
  };

  const saveEdit = () => {
    if (editValue.trim()) {
      onSave(editValue.trim());
      setIsEditing(false);
    }
  };

  const cancelEdit = () => {
    setEditValue(initialValue);
    setIsEditing(false);
  };

  return {
    isEditing,
    editValue,
    setEditValue,
    startEditing,
    saveEdit,
    cancelEdit,
  };
}
